// This file is auto-generated by @hey-api/openapi-ts

import * as v from "valibot";

export const vAbstractPersistentObject = v.object({
  id: v.nullish(v.string())
});

export const vArtificialAvalancheReleaseProbability = v.picklist([
  "one",
  "two",
  "three",
  "four"
]);

export const vAspect = v.picklist(["N", "NE", "E", "SE", "S", "SW", "W", "NW"]);

export const vAuthenticationServiceCredentials = v.object({
  username: v.string(),
  password: v.string()
});

export const vAuthenticationServiceUsername = v.object({
  username: v.string()
});

export const vAvalancheBulletinValidity = v.object({
  from: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  until: v.optional(v.pipe(v.string(), v.isoTimestamp()))
});

export const vAvalancheBulletinPhoto = v.intersect([
  vAbstractPersistentObject,
  v.object({
    id: v.nullish(v.string()),
    url: v.optional(v.string()),
    copyright: v.optional(v.string()),
    date: v.optional(v.pipe(v.string(), v.isoDate())),
    microRegionId: v.optional(v.string()),
    locationName: v.optional(v.string()),
    latitude: v.optional(v.number()),
    longitude: v.optional(v.number())
  })
]);

export const vAvalancheBulletinServiceLatestBulletin = v.object({
  date: v.pipe(v.string(), v.isoTimestamp())
});

export const vAvalancheProblem1 = v.picklist([
  "new_snow",
  "wind_slab",
  "persistent_weak_layers",
  "wet_snow",
  "gliding_snow",
  "favourable_situation",
  "cornices",
  "no_distinct_avalanche_problem"
]);

export const vAvalancheSize = v.picklist([
  "small",
  "medium",
  "large",
  "very_large",
  "extreme"
]);

export const vAvalancheType = v.picklist(["slab", "loose", "glide"]);

export const vBlogItem = v.object({
  id: v.string(),
  title: v.string(),
  content: v.string(),
  published: v.pipe(v.string(), v.isoTimestamp()),
  categories: v.array(v.string()),
  attachmentUrl: v.string(),
  translations: v.object({
    de: v.optional(v.string()),
    it: v.optional(v.string()),
    en: v.optional(v.string()),
    fr: v.optional(v.string()),
    es: v.optional(v.string()),
    ca: v.optional(v.string()),
    oc: v.optional(v.string())
  })
});

export const vBulletinStatus = v.picklist([
  "republished",
  "resubmitted",
  "updated",
  "published",
  "submitted",
  "draft",
  "missing"
]);

export const vAvalancheBulletinStatusServiceStatus = v.object({
  date: v.pipe(v.string(), v.isoTimestamp()),
  timestamp: v.pipe(v.string(), v.isoTimestamp()),
  status: vBulletinStatus,
  isBeingPublished: v.boolean()
});

/**
 * An aspect can be defined as a set of aspects. The aspects are the expositions as in a eight part (45°) segments. The allowed aspects are the four main cardinal directions and the four intercardinal directions.
 */
export const vCaamlAspect = v.picklist([
  "E",
  "N",
  "NE",
  "NW",
  "n/a",
  "S",
  "SE",
  "SW",
  "W"
]);

export const vCaamlAvalancheBulletinCustomDataBulletinPhoto = v.object({
  url: v.string(),
  copyright: v.nullish(v.string()),
  date: v.nullish(v.pipe(v.string(), v.isoDate())),
  microRegionId: v.nullish(v.string()),
  locationName: v.nullish(v.string()),
  latitude: v.nullish(v.number()),
  longitude: v.nullish(v.number())
});

export const vCaamlAvalancheBulletinCustomDataLwdTyrol = v.object({
  dangerPatterns: v.nullish(v.array(v.string()))
});

export const vCaamlAvalancheBulletinsCustomDataAlbina = v.object({
  generalHeadline: v.string()
});

export const vCaamlAvalancheBulletinsCustomData = v.object({
  ALBINA: vCaamlAvalancheBulletinsCustomDataAlbina
});

export const vCaamlAvalancheProblemCustomDataAlbina = v.object({
  avalancheType: v.string()
});

export const vCaamlAvalancheProblemCustomData = v.object({
  ALBINA: vCaamlAvalancheProblemCustomDataAlbina
});

/**
 * Expected avalanche problem, according to the EAWS avalanche problem definition.
 */
export const vCaamlAvalancheProblemType = v.picklist([
  "cornices",
  "favourable_situation",
  "gliding_snow",
  "new_snow",
  "no_distinct_avalanche_problem",
  "persistent_weak_layers",
  "wet_snow",
  "wind_slab"
]);

/**
 * Expected avalanche type.
 */
export const vCaamlAvalancheTypeType = v.picklist(["slab", "loose", "glide"]);

/**
 * Danger rating value, according to EAWS danger scale definition.
 */
export const vCaamlDangerRatingValue = v.picklist([
  "considerable",
  "high",
  "low",
  "moderate",
  "no_rating",
  "no_snow",
  "very_high"
]);

export const vCaamlAvalancheBulletinCustomDataTendencyProgression = v.object({
  dates: v.array(v.pipe(v.string(), v.isoDate())),
  dangerRatings: v.record(v.string(), v.array(vCaamlDangerRatingValue))
});

export const vCaamlAvalancheBulletinCustomDataAlbina = v.object({
  mainDate: v.string(),
  tendencyProgression: v.nullish(
    vCaamlAvalancheBulletinCustomDataTendencyProgression
  ),
  bulletinPhotos: v.nullish(
    v.array(vCaamlAvalancheBulletinCustomDataBulletinPhoto)
  )
});

export const vCaamlAvalancheBulletinCustomData = v.object({
  ALBINA: vCaamlAvalancheBulletinCustomDataAlbina,
  LWD_Tyrol: vCaamlAvalancheBulletinCustomDataLwdTyrol
});

/**
 * Elevation describes either an elevation range below a certain bound (only upperBound is set to a value) or above a certain bound (only lowerBound is set to a value). If both values are set to a value, an elevation band is defined by this property. The value uses a numeric value, not more detailed than 100m resolution. Additionally to the numeric values also 'treeline' is allowed.
 */
export const vCaamlElevationBoundaryOrBand = v.object({
  lowerBound: v.optional(v.string()),
  upperBound: v.optional(v.string())
});

/**
 * Expected frequency of lowest snowpack stability, according to the EAWS definition. Three stage scale (few, some, many).
 */
export const vCaamlExpectedAvalancheFrequency = v.picklist([
  "few",
  "many",
  "none",
  "some"
]);

/**
 * Snowpack stability, according to the EAWS definition. Four stage scale (very poor, poor, fair, good).
 */
export const vCaamlExpectedSnowpackStability = v.picklist([
  "fair",
  "good",
  "poor",
  "very_poor"
]);

/**
 * External file is used to link to external files like maps, thumbnails etc.
 */
export const vCaamlExternalFile = v.object({
  description: v.optional(v.string()),
  fileReferenceURI: v.optional(v.string()),
  fileType: v.optional(v.string())
});

/**
 * Meta data for various uses. Can be used to link to external files like maps, thumbnails etc.
 */
export const vCaamlMetaData = v.object({
  comment: v.optional(v.string()),
  EXTFiles: v.optional(v.array(vCaamlExternalFile))
});

/**
 * Details on a person.
 */
export const vCaamlPerson = v.object({
  customData: v.optional(v.record(v.string(), v.unknown())),
  metaData: v.optional(vCaamlMetaData),
  name: v.optional(v.string()),
  website: v.optional(v.string())
});

/**
 * Information about the bulletin provider. Defines the name, website and/or contactPerson (which could be the author) of the issuing AWS.
 */
export const vCaamlAvalancheBulletinProvider = v.object({
  contactPerson: v.optional(vCaamlPerson),
  customData: v.optional(v.record(v.string(), v.unknown())),
  metaData: v.optional(vCaamlMetaData),
  name: v.optional(v.string()),
  website: v.optional(v.string())
});

/**
 * Details about the issuer/AWS of the bulletin. Information about the bulletin source. Either as in a person or with a provider element to specify details about the AWS.
 */
export const vCaamlAvalancheBulletinSource = v.object({
  person: v.optional(vCaamlPerson),
  provider: v.optional(vCaamlAvalancheBulletinProvider)
});

/**
 * Region element describes a (micro) region. The regionID follows the EAWS schema. It is recommended to have the region shape's files with the same IDs in gitlab.com/eaws/eaws-regions. Additionally, the region name can be added.
 */
export const vCaamlRegion = v.object({
  customData: v.optional(v.record(v.string(), v.unknown())),
  metaData: v.optional(vCaamlMetaData),
  name: v.optional(v.string()),
  regionID: v.optional(v.string())
});

export const vCaamlTendencyType = v.picklist([
  "decreasing",
  "increasing",
  "steady"
]);

/**
 * Texts element with highlight and comment for the avalanche activity. Texts contains a highlight and a comment string, where highlights could also be described as a kind of headline for the longer comment. For text-formatting the HTML-Tags
 * for a new line, (
 *
 * ,) and (
 * * ,
 * * ) for lists, (
 *
 * ,
 * ===
 *
 * ) to (
 * ======
 *
 * ###### ,
 *
 * ###### ) for
 * headings and (**,**) for a bold text are allowed.
 * Texts element with highlight and comment for details on the snowpack structure.
 * Texts element with highlight and comment for travel advisory.
 * Texts element with highlight and comment for weather forecast information.
 * Texts element with highlight and comment for weather review information.
 */
export const vCaamlTexts = v.object({
  comment: v.optional(v.string()),
  highlights: v.optional(v.string())
});

/**
 * Valid time defines two ISO 8601 timestamps in UTC or with time zone information. Date and Time from and until this bulletin is valid. ISO 8601 Timestamp in UTC or with time zone information.
 */
export const vCaamlValidTime = v.object({
  endTime: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  startTime: v.optional(v.pipe(v.string(), v.isoTimestamp()))
});

/**
 * Texts element with highlight and comment for the avalanche activity. Texts contains a highlight and a comment string, where highlights could also be described as a kind of headline for the longer comment. For text-formatting the HTML-Tags
 * for a new line, (
 *
 * ,) and (
 * * ,
 * * ) for lists, (
 *
 * ,
 * ===
 *
 * ) to (
 * ======
 *
 * ###### ,
 *
 * ###### ) for
 * headings and (**,**) for a bold text are allowed.
 * Texts element with highlight and comment for details on the snowpack structure.
 * Texts element with highlight and comment for travel advisory.
 * Texts element with highlight and comment for weather forecast information.
 * Texts element with highlight and comment for weather review information.
 * Describes the expected tendency of the development of the avalanche situation for a
 * defined time period.
 */
export const vCaamlTendency = v.object({
  comment: v.optional(v.string()),
  highlights: v.optional(v.string()),
  customData: v.optional(v.record(v.string(), v.unknown())),
  metaData: v.optional(vCaamlMetaData),
  tendencyType: v.optional(vCaamlTendencyType),
  validTime: v.optional(vCaamlValidTime)
});

/**
 * Valid time period can be used to limit the validity of an element to an earlier or later period. It can be used to distinguish danger ratings or avalanche problems.
 */
export const vCaamlValidTimePeriod = v.picklist([
  "all_day",
  "earlier",
  "later"
]);

/**
 * Defines an avalanche problem, its time, aspect, and elevation constraints. A textual detail about the affected terrain can be given in the comment field. Also, details about the expected avalanche size, snowpack stability and its frequency can be defined. The implied danger rating value is optional.
 */
export const vCaamlAvalancheProblem = v.object({
  aspects: v.optional(v.array(vCaamlAspect)),
  avalancheSize: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        "Invalid value: Expected int32 to be >= -2147483648"
      ),
      v.maxValue(
        2147483647,
        "Invalid value: Expected int32 to be <= 2147483647"
      )
    )
  ),
  comment: v.optional(v.string()),
  customData: v.optional(vCaamlAvalancheProblemCustomData),
  dangerRatingValue: v.optional(vCaamlDangerRatingValue),
  elevation: v.optional(vCaamlElevationBoundaryOrBand),
  frequency: v.optional(vCaamlExpectedAvalancheFrequency),
  metaData: v.optional(vCaamlMetaData),
  problemType: v.optional(vCaamlAvalancheProblemType),
  avalancheType: v.optional(vCaamlAvalancheTypeType),
  snowpackStability: v.optional(vCaamlExpectedSnowpackStability),
  validTimePeriod: v.optional(vCaamlValidTimePeriod)
});

/**
 * Defines a danger rating, its elevation constraints and the valid time period. If validTimePeriod or elevation are constrained for a rating, it is expected to define a dangerRating for all the other cases.
 */
export const vCaamlDangerRating = v.object({
  aspects: v.optional(v.array(vCaamlAspect)),
  customData: v.optional(v.record(v.string(), v.unknown())),
  elevation: v.optional(vCaamlElevationBoundaryOrBand),
  mainValue: v.optional(vCaamlDangerRatingValue),
  metaData: v.optional(vCaamlMetaData),
  validTimePeriod: v.optional(vCaamlValidTimePeriod)
});

/**
 * Avalanche Bulletin valid for a given set of regions.
 */
export const vCaamlAvalancheBulletin = v.object({
  avalancheActivity: v.optional(vCaamlTexts),
  avalancheProblems: v.optional(v.array(vCaamlAvalancheProblem)),
  bulletinID: v.optional(v.string()),
  customData: v.optional(vCaamlAvalancheBulletinCustomData),
  dangerRatings: v.optional(v.array(vCaamlDangerRating)),
  highlights: v.optional(v.string()),
  lang: v.optional(v.string()),
  metaData: v.optional(vCaamlMetaData),
  nextUpdate: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  publicationTime: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  regions: v.optional(v.array(vCaamlRegion)),
  snowpackStructure: v.optional(vCaamlTexts),
  source: v.optional(vCaamlAvalancheBulletinSource),
  tendency: v.optional(v.array(vCaamlTendency)),
  travelAdvisory: v.optional(vCaamlTexts),
  unscheduled: v.optional(v.boolean()),
  validTime: v.optional(vCaamlValidTime),
  weatherForecast: v.optional(vCaamlTexts),
  weatherReview: v.optional(vCaamlTexts)
});

/**
 * JSON schema for EAWS avalanche bulletin collection following the CAAMLv6 schema
 */
export const vCaamlAvalancheBulletins = v.object({
  bulletins: v.optional(v.array(vCaamlAvalancheBulletin)),
  customData: v.optional(vCaamlAvalancheBulletinsCustomData),
  metaData: v.optional(vCaamlMetaData)
});

/**
 * The version of CAAML (Canadian Avalanche Association Markup Language)
 */
export const vCaamlVersion = v.picklist(["V6", "V6_JSON"]);

export const vCharacteristic = v.picklist([
  "low",
  "medium",
  "high",
  "very_high"
]);

export const vComplexity = v.picklist(["easy", "challenging", "complex"]);

export const vCreationProcess = v.picklist([
  "radiation_recrystallization",
  "diurnal_recrystallization",
  "melt_layer_recrystallization",
  "surface_hoar_formation"
]);

export const vCrust = v.picklist(["no", "partly", "yes"]);

export const vDangerPattern = v.picklist([
  "dp1",
  "dp2",
  "dp3",
  "dp4",
  "dp5",
  "dp6",
  "dp7",
  "dp8",
  "dp9",
  "dp10"
]);

export const vDangerRating = v.picklist([
  "missing",
  "no_snow",
  "no_rating",
  "low",
  "moderate",
  "considerable",
  "high",
  "very_high"
]);

export const vAvalancheBulletinServiceHighest = v.object({
  dangerRating: vDangerRating
});

export const vDangerRatingModificator = v.picklist([
  "none",
  "minus",
  "equal",
  "plus"
]);

export const vDangerSign = v.picklist([
  "shooting_cracks",
  "whumpfing",
  "fresh_avalanches",
  "glide_cracks"
]);

/**
 * This class holds all information about one danger source.
 */
export const vDangerSource = v.intersect([
  vAbstractPersistentObject,
  v.object({
    id: v.nullish(v.string()),
    ownerRegion: v.optional(v.string()),
    creationDate: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    title: v.optional(v.string()),
    description: v.optional(v.string())
  })
]);

export const vDangerSourceVariantStatus = v.picklist([
  "active",
  "dormant",
  "inactive"
]);

export const vDangerSourceVariantType = v.picklist(["forecast", "analysis"]);

export const vDangerSourceVariantsStatus = v.object({
  date: v.pipe(v.string(), v.isoTimestamp()),
  forecast: v.boolean(),
  analysis: v.boolean()
});

export const vDaytime = v.picklist([
  "evening",
  "first_night_half",
  "second_night_half",
  "morning",
  "forenoon",
  "afternoon"
]);

export const vDirection = v.picklist(["up", "down"]);

export const vDistribution = v.picklist(["isolated", "specific", "widespread"]);

export const vFrequency = v.picklist(["none", "few", "some", "many"]);

export const vGenericObservationImportantObservation = v.picklist([
  "SnowLine",
  "SurfaceHoar",
  "Graupel",
  "StabilityTest",
  "IceFormation",
  "VeryLightNewSnow",
  "ForBlog"
]);

export const vGenericObservationObservationType = v.picklist([
  "SimpleObservation",
  "Evaluation",
  "Avalanche",
  "Blasting",
  "Closure",
  "Profile",
  "TimeSeries",
  "Webcam",
  "DrySnowfallLevel"
]);

export const vGenericObservationPersonInvolvement = v.picklist([
  "Dead",
  "Injured",
  "Uninjured",
  "No",
  "Unknown"
]);

export const vGenericObservation = v.object({
  $source: v.string(),
  $id: v.string(),
  $type: vGenericObservationObservationType,
  $externalURL: v.optional(v.string()),
  stability: v.optional(v.string()),
  aspects: v.optional(v.array(vAspect)),
  authorName: v.optional(v.string()),
  content: v.optional(v.string()),
  $data: v.optional(v.record(v.string(), v.unknown())),
  elevation: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        "Invalid value: Expected int32 to be >= -2147483648"
      ),
      v.maxValue(
        2147483647,
        "Invalid value: Expected int32 to be <= 2147483647"
      )
    )
  ),
  elevationLowerBound: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        "Invalid value: Expected int32 to be >= -2147483648"
      ),
      v.maxValue(
        2147483647,
        "Invalid value: Expected int32 to be <= 2147483647"
      )
    )
  ),
  elevationUpperBound: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        "Invalid value: Expected int32 to be >= -2147483648"
      ),
      v.maxValue(
        2147483647,
        "Invalid value: Expected int32 to be <= 2147483647"
      )
    )
  ),
  eventDate: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  latitude: v.optional(v.number()),
  locationName: v.optional(v.string()),
  longitude: v.optional(v.number()),
  region: v.optional(v.string()),
  reportDate: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  avalancheProblems: v.optional(v.array(vAvalancheProblem1)),
  dangerPatterns: v.optional(v.array(vDangerPattern)),
  importantObservation: v.optional(
    v.array(vGenericObservationImportantObservation)
  ),
  extraDialogRows: v.optional(v.record(v.string(), v.unknown())),
  $externalImgs: v.optional(v.string()),
  personInvolvement: v.optional(vGenericObservationPersonInvolvement),
  $deleted: v.optional(v.boolean()),
  allowEdit: v.optional(v.boolean()),
  dangerSource: v.nullish(vDangerSource)
});

export const vGlidingSnowActivity = v.picklist(["low", "medium", "high"]);

export const vGrainShape = v.picklist([
  "PP",
  "MM",
  "DF",
  "RG",
  "FC",
  "DH",
  "SH",
  "MF",
  "IF",
  "PPco",
  "PPnd",
  "PPpl",
  "PPsd",
  "PPir",
  "PPgp",
  "PPhl",
  "PPip",
  "PPrm",
  "MMrp",
  "MMci",
  "DFdc",
  "DFbk",
  "RGsr",
  "RGlr",
  "RGwp",
  "RGxf",
  "FCso",
  "FCsf",
  "FCxr",
  "DHcp",
  "DHpr",
  "DHch",
  "DHla",
  "DHxr",
  "SHsu",
  "SHcv",
  "SHxr",
  "MFcl",
  "MFpc",
  "MFsl",
  "MFcr",
  "IFil",
  "IFic",
  "IFbi",
  "IFrc",
  "IFsc"
]);

export const vHandHardness = v.picklist([
  "fist",
  "four_fingers",
  "one_finger",
  "pencil",
  "knife",
  "ice"
]);

export const vHazardSiteDistribution = v.picklist([
  "single",
  "some",
  "many",
  "many_most",
  "moderately_steep"
]);

export const vIncident = v.intersect([
  vAbstractPersistentObject,
  v.object({
    id: v.nullish(v.string()),
    createdAt: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    updatedAt: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    data: v.optional(v.record(v.string(), v.unknown())),
    publishedAt: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    publicData: v.optional(v.record(v.string(), v.unknown()))
  })
]);

export const vIncidentAttachment = v.object({
  id: v.pipe(v.string(), v.uuid()),
  dateAdded: v.pipe(v.string(), v.isoTimestamp()),
  fileName: v.string(),
  mediaType: v.string(),
  dateCreated: v.pipe(v.string(), v.isoTimestamp()),
  credit: v.string(),
  caption: v.string(),
  altText: v.string(),
  public: v.boolean(),
  attachmentCategory: v.string(),
  attachmentTags: v.array(v.string())
});

export const vIncidentsAccidentalControlled = v.picklist([
  "Accidental",
  "Controlled"
]);

export const vIncidentsAdditionalLoad = v.picklist(["High", "Low"]);

export const vIncidentsAge = v.picklist([
  "From14To20",
  "From21To30",
  "From31To40",
  "From41To50",
  "From51To60",
  "From61To70",
  "From71",
  "UpTo13"
]);

export const vIncidentsAirbag = v.picklist([
  "AirbagDeployed",
  "AirbagUndeployed",
  "NoAirbag"
]);

export const vIncidentsAttachmentCategory = v.picklist([
  "Avalanche",
  "Group",
  "Incident",
  "Person",
  "Snowpack",
  "Weather"
]);

export const vIncidentsAttachment = v.object({
  altText: v.string(),
  attachmentCategory: vIncidentsAttachmentCategory,
  attachmentTags: v.array(v.string()),
  caption: v.string(),
  credit: v.string(),
  dateAdded: v.pipe(v.string(), v.isoTimestamp()),
  dateCreated: v.pipe(v.string(), v.isoTimestamp()),
  fileName: v.string(),
  id: v.pipe(v.string(), v.uuid()),
  mediaType: v.string(),
  public: v.boolean()
});

export const vIncidentsAvalancheGear = v.picklist([
  "All",
  "None",
  "Some",
  "Unknown"
]);

export const vIncidentsAvalancheProblemAvalancheSize = v.picklist([
  "extreme",
  "large",
  "medium",
  "small",
  "very_large"
]);

export const vIncidentsAvalancheType = v.picklist([
  "cornice",
  "glide",
  "loose",
  "slab",
  "unknown"
]);

export const vIncidentsBedSurfaceStepped = v.picklist(["No", "Yes"]);

export const vIncidentsBurialDegree = v.picklist([
  "FullyBuried",
  "NotBuried",
  "PartlyBuried",
  "PartlyBuriedHeadCovered",
  "PartlyBuriedHeadUncovered",
  "Unknown"
]);

export const vIncidentsCaught = v.picklist([
  "Involved",
  "NotInvolved",
  "Unknown"
]);

export const vIncidentsCriticalWarming = v.picklist([
  "Absent",
  "Present",
  "Unknown"
]);

export const vIncidentsDangerPattern = v.picklist([
  "dp1",
  "dp10",
  "dp2",
  "dp3",
  "dp4",
  "dp5",
  "dp6",
  "dp7",
  "dp8",
  "dp9"
]);

export const vIncidentsDangerRating = v.picklist([
  "considerable",
  "high",
  "low",
  "moderate",
  "no_rating",
  "no_snow",
  "very_high"
]);

export const vIncidentsDepositMoisture = v.picklist(["Dry", "Moist", "Wet"]);

export const vIncidentsEstimatedTimeOfDeath = v.picklist([
  "DuringBurial",
  "DuringTheAvalanche",
  "DuringTransport",
  "InHospital",
  "OnSiteAfterExtrication"
]);

export const vIncidentsFatalInjured = v.picklist([
  "Fatal",
  "Injured",
  "Uninjured",
  "Unknown"
]);

export const vIncidentsFrequency = v.picklist(["few", "many", "none", "some"]);

export const vIncidentsGender = v.picklist(["Female", "Male", "Other"]);

export const vIncidentsGroupSizeAccuracy = v.picklist([
  "Approximately",
  "AtLeast",
  "Exact",
  "Unknown"
]);

export const vIncidentsIncidentSchemaAvalancheSize = v.picklist([
  "extreme",
  "large",
  "large_very_large",
  "medium",
  "medium_large",
  "small",
  "small_medium",
  "unknown",
  "very_large",
  "very_large_extreme"
]);

export const vIncidentsIncidentTerrainType = v.picklist([
  "ControlledTerrainClosed",
  "ControlledTerrainOpen",
  "FreeTerrain",
  "Unknown"
]);

export const vIncidentsGroupInformation = v.object({
  anonymousGroupIdentifier: v.string(),
  avalancheGear: vIncidentsAvalancheGear,
  groupInformationComment: v.string(),
  groupSize: v.number(),
  groupSizeAccuracy: vIncidentsGroupSizeAccuracy,
  groupType: v.string(),
  id: v.pipe(v.string(), v.uuid()),
  incidentActivity: v.string(),
  incidentTerrainType: vIncidentsIncidentTerrainType,
  travelDirection: v.string(),
  typeOfControlledTerrain: v.string(),
  vehicleType: v.string()
});

export const vIncidentsInjurySeverity = v.picklist([
  "Major",
  "Minor",
  "Moderate"
]);

export const vIncidentsInvolvementsFatalitiesBurials = v.object({
  caughtOnly: v.number(),
  fatalities: v.number(),
  fullyBuried: v.number(),
  incidentActivity: v.array(v.string()),
  incidentTerrainType: v.array(vIncidentsIncidentTerrainType),
  injuredSurvivors: v.number(),
  involvementsFatalitiesBurialsComment: v.string(),
  numberInvolved: v.number(),
  numberOfGroups: v.number(),
  partlyBuried: v.number(),
  partlyBuriedHeadCovered: v.number(),
  partlyBuriedHeadUncovered: v.number(),
  uninjuredSurvivors: v.number()
});

export const vIncidentsLocationAccuracy = v.picklist([
  "exact",
  "unknown",
  "within100m",
  "within10km",
  "within15m",
  "within1km",
  "within20km",
  "within250m",
  "within2km",
  "within30m",
  "within500m",
  "within50km",
  "within5km"
]);

export const vIncidentsNatural = v.picklist([
  "CorniceFall",
  "Earthquake",
  "IceFall",
  "Natural",
  "RockFall"
]);

export const vIncidentsPerson = v.picklist([
  "PersonAccidental",
  "PersonControlled"
]);

export const vIncidentsPersonInvolvement = v.picklist(["No", "Unknown", "Yes"]);

export const vIncidentsProblemType = v.picklist([
  "cornices",
  "gliding_snow",
  "new_snow",
  "no_distinct_avalanche_problem",
  "persistent_weak_layers",
  "wet_snow",
  "wind_slab"
]);

export const vIncidentsReportStatus = v.picklist([
  "Draft",
  "InReview",
  "Incomplete",
  "Verified"
]);

export const vIncidentsSnowpackStability = v.picklist([
  "fair",
  "good",
  "poor",
  "very_poor"
]);

export const vIncidentsStartZoneAspect = v.picklist([
  "E",
  "N",
  "NE",
  "NW",
  "S",
  "SE",
  "SW",
  "W"
]);

export const vIncidentsAvalancheProblem = v.object({
  aspects: v.array(vIncidentsStartZoneAspect),
  avalancheSize: vIncidentsAvalancheProblemAvalancheSize,
  elevationLowerBound: v.string(),
  elevationUpperBound: v.string(),
  frequency: vIncidentsFrequency,
  problemType: vIncidentsProblemType,
  snowpackStability: vIncidentsSnowpackStability
});

export const vIncidentsStartZoneAspectAccuracy = v.picklist([
  "Accurate",
  "Uncertain"
]);

export const vIncidentsStartZoneElevationAccuracy = v.picklist([
  "exact",
  "unknown",
  "within100m",
  "within200m",
  "within50m"
]);

export const vIncidentsStartZoneMoisture = v.picklist([
  "Dry",
  "Moist",
  "Unknown",
  "Wet"
]);

export const vIncidentsTimeAccuracy = v.picklist([
  "P1D",
  "P2D",
  "P3D",
  "PT12H",
  "PT15M",
  "PT1H",
  "PT2H",
  "PT30M",
  "PT4H",
  "PT6H",
  "exact",
  "unknown"
]);

export const vIncidentsTransceiver = v.picklist([
  "NoTransceiver",
  "TransceiverOff",
  "TransceiverOn"
]);

export const vIncidentsWeakLayerGrainType = v.picklist([
  "DF",
  "DH",
  "FC",
  "FCxr",
  "MF",
  "MM",
  "PP",
  "PPgp",
  "RG",
  "SH"
]);

export const vIncidentsWeakLayerLocation = v.picklist([
  "AtInterfaceWithOldSnow",
  "NearTheGround",
  "WithinNewSnow",
  "WithinOldSnowpack"
]);

export const vIncidentsYearsActive = v.picklist([
  "From10Years",
  "From3To9Years",
  "UpTo2Years"
]);

export const vIncidentsVictimInformation = v.object({
  age: vIncidentsAge,
  airbag: vIncidentsAirbag,
  anonymousVictimIdentifier: v.string(),
  avalancheTraining: v.string(),
  burialDegree: vIncidentsBurialDegree,
  burialDepth: v.number(),
  burialDuration: v.number(),
  caught: vIncidentsCaught,
  causeOfDeath: v.string(),
  country: v.string(),
  estimatedTimeOfDeath: vIncidentsEstimatedTimeOfDeath,
  fatalInjured: vIncidentsFatalInjured,
  gender: vIncidentsGender,
  groupID: v.pipe(v.string(), v.uuid()),
  helmet: vIncidentsBedSurfaceStepped,
  id: v.pipe(v.string(), v.uuid()),
  injurySeverity: vIncidentsInjurySeverity,
  leaderAtTime: vIncidentsBedSurfaceStepped,
  medicalIntervention: v.string(),
  primaryLocationMethod: v.string(),
  probe: vIncidentsBedSurfaceStepped,
  professionalCertification: v.string(),
  rescuedBy: v.string(),
  respiratoryCavity: vIncidentsBedSurfaceStepped,
  shovel: vIncidentsBedSurfaceStepped,
  terrainTrap: v.string(),
  transceiver: vIncidentsTransceiver,
  victimInformationComment: v.string(),
  workingAtTime: vIncidentsBedSurfaceStepped,
  yearsActive: vIncidentsYearsActive
});

export const vIncidentsIncidentSchema = v.object({
  accidentalControlled: vIncidentsAccidentalControlled,
  additionalLoad: vIncidentsAdditionalLoad,
  attachments: v.array(vIncidentsAttachment),
  author: v.string(),
  authorAffiliation: v.string(),
  avalancheDescription: v.record(v.string(), v.string()),
  avalancheDescriptionPublic: v.boolean(),
  avalancheDetailsComment: v.string(),
  avalancheLength: v.number(),
  avalancheProblems: v.array(vIncidentsAvalancheProblem),
  avalancheRegion: v.string(),
  avalancheSize: vIncidentsIncidentSchemaAvalancheSize,
  avalancheType: vIncidentsAvalancheType,
  bedSurfaceStepped: vIncidentsBedSurfaceStepped,
  bulletinInformationComment: v.string(),
  country: v.string(),
  criticalWarming: vIncidentsCriticalWarming,
  crownDepthAvg: v.number(),
  crownDepthMax: v.number(),
  crownDepthMin: v.number(),
  damagedAssets: v.array(v.string()),
  dangerPattern: v.array(vIncidentsDangerPattern),
  dangerRating: vIncidentsDangerRating,
  dateTime: v.pipe(v.string(), v.isoTimestamp()),
  debrisDensity: v.number(),
  debrisType: v.array(v.string()),
  depositElevation: v.number(),
  depositHeight: v.number(),
  depositMoisture: vIncidentsDepositMoisture,
  depositWidth: v.number(),
  explosives: v.string(),
  generalInformationComment: v.string(),
  groupInformation: v.array(vIncidentsGroupInformation),
  id: v.pipe(v.string(), v.uuid()),
  incidentAnalysisComment: v.string(),
  incidentDescription: v.record(v.string(), v.string()),
  incidentDescriptionPublic: v.boolean(),
  incidentLede: v.record(v.string(), v.string()),
  incidentLedePublic: v.boolean(),
  involvementsFatalitiesBurials: vIncidentsInvolvementsFatalitiesBurials,
  latitude: v.number(),
  lineCoordinatesText: v.string(),
  location: v.string(),
  locationAccuracy: vIncidentsLocationAccuracy,
  longitude: v.number(),
  multipleAvalanches: vIncidentsBedSurfaceStepped,
  municipality: v.string(),
  natural: vIncidentsNatural,
  otherDamages: vIncidentsBedSurfaceStepped,
  otherDamagesComment: v.string(),
  person: vIncidentsPerson,
  personInvolvement: vIncidentsPersonInvolvement,
  polygonCoordinatesText: v.string(),
  privateExternalDatabaseLinks: v.string(),
  privateExternalLinks: v.string(),
  publicAvalancheWarningService: v.string(),
  publicAvalancheWarningServiceOutside: v.boolean(),
  publicExternalLinks: v.string(),
  publishedAt: v.pipe(v.string(), v.isoTimestamp()),
  recentLoading: vIncidentsCriticalWarming,
  recentSlabAvalanches: vIncidentsCriticalWarming,
  region: v.string(),
  relevantAvalancheProblem: vIncidentsProblemType,
  remoteTriggering: vIncidentsBedSurfaceStepped,
  reportStatus: vIncidentsReportStatus,
  signsOfInstability: vIncidentsCriticalWarming,
  slabWidth: v.number(),
  snowpackDescription: v.record(v.string(), v.string()),
  snowpackDescriptionPublic: v.boolean(),
  sourceOfInformation: v.array(v.string()),
  startZoneAspect: vIncidentsStartZoneAspect,
  startZoneAspectAccuracy: vIncidentsStartZoneAspectAccuracy,
  startZoneElevation: v.number(),
  startZoneElevationAccuracy: vIncidentsStartZoneElevationAccuracy,
  startZoneIncline: v.number(),
  startZoneMoisture: vIncidentsStartZoneMoisture,
  startZoneTerrainType: v.array(v.string()),
  takeAways: v.record(v.string(), v.string()),
  takeAwaysPublic: v.boolean(),
  timeAccuracy: vIncidentsTimeAccuracy,
  trigger: v.string(),
  updatedAt: v.pipe(v.string(), v.isoTimestamp()),
  vehicle: v.string(),
  victimInformation: v.array(vIncidentsVictimInformation),
  weakLayerGrainSize1: v.number(),
  weakLayerGrainSize2: v.number(),
  weakLayerGrainType1: vIncidentsWeakLayerGrainType,
  weakLayerGrainType2: vIncidentsWeakLayerGrainType,
  weakLayerLocation: vIncidentsWeakLayerLocation,
  weakLayerName: v.string(),
  weatherDescription: v.record(v.string(), v.string()),
  weatherDescriptionPublic: v.boolean()
});

/**
 * The enum contains the ISO 639-1 codes for available languages.
 */
export const vLanguageCode = v.picklist([
  "de",
  "it",
  "en",
  "fr",
  "es",
  "ca",
  "oc"
]);

export const vAvalancheBulletinText = v.object({
  languageCode: vLanguageCode,
  text: v.string()
});

export const vLocalServerInstance = v.object({
  publishAt5PM: v.boolean(),
  publishAt8AM: v.boolean(),
  mapsPath: v.string(),
  mapProductionUrl: v.string(),
  pdfDirectory: v.string(),
  htmlDirectory: v.string(),
  mediaPath: v.string()
});

export const vNaturalAvalancheReleaseProbability = v.picklist([
  "one",
  "two",
  "three",
  "four"
]);

export const vMatrixInformation = v.object({
  artificialDangerRating: v.optional(vDangerRating),
  artificialAvalancheSize: v.optional(vAvalancheSize),
  artificialAvalancheReleaseProbability: v.optional(
    vArtificialAvalancheReleaseProbability
  ),
  artificialHazardSiteDistribution: v.optional(vHazardSiteDistribution),
  naturalDangerRating: v.optional(vDangerRating),
  naturalAvalancheReleaseProbability: v.optional(
    vNaturalAvalancheReleaseProbability
  ),
  naturalHazardSiteDistribution: v.optional(vHazardSiteDistribution)
});

export const vPasskeyServiceAssertionResponse = v.object({
  clientDataJSON: v.string(),
  authenticatorData: v.string(),
  signature: v.string(),
  userHandle: v.nullish(v.string())
});

export const vPasskeyServiceAttestationResponse = v.object({
  clientDataJSON: v.string(),
  attestationObject: v.string()
});

export const vPasskeyServiceAuthenticationCredential = v.object({
  id: v.string(),
  type: v.string(),
  response: vPasskeyServiceAssertionResponse
});

export const vPasskeyServiceAuthenticatorSelection = v.object({
  residentKey: v.string(),
  userVerification: v.string()
});

export const vPasskeyServiceCredentialDescriptor = v.object({
  type: v.string(),
  id: v.string()
});

export const vPasskeyServiceLoginBeginRequest = v.object({
  username: v.nullish(v.string())
});

export const vPasskeyServiceLoginFinishRequest = v.object({
  state: v.string(),
  credential: vPasskeyServiceAuthenticationCredential
});

/**
 * What a passkey management UI needs to show --- never the credential ID or public key.
 */
export const vPasskeyServicePasskeyInfo = v.object({
  id: v.string(),
  name: v.nullish(v.string()),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  lastUsedAt: v.nullish(v.pipe(v.string(), v.isoTimestamp()))
});

export const vPasskeyServicePubKeyCredParam = v.object({
  type: v.string(),
  alg: v.pipe(
    v.union([v.number(), v.string(), v.bigint()]),
    v.transform(x => BigInt(x)),
    v.minValue(
      BigInt("-9223372036854775808"),
      "Invalid value: Expected int64 to be >= -9223372036854775808"
    ),
    v.maxValue(
      BigInt("9223372036854775807"),
      "Invalid value: Expected int64 to be <= 9223372036854775807"
    )
  )
});

export const vPasskeyServicePublicKeyCredentialRequestOptions = v.object({
  challenge: v.string(),
  rpId: v.string(),
  allowCredentials: v.array(vPasskeyServiceCredentialDescriptor),
  userVerification: v.string(),
  timeout: v.pipe(
    v.union([v.number(), v.string(), v.bigint()]),
    v.transform(x => BigInt(x)),
    v.minValue(
      BigInt("-9223372036854775808"),
      "Invalid value: Expected int64 to be >= -9223372036854775808"
    ),
    v.maxValue(
      BigInt("9223372036854775807"),
      "Invalid value: Expected int64 to be <= 9223372036854775807"
    )
  )
});

export const vPasskeyServiceLoginChallenge = v.object({
  state: v.string(),
  publicKey: vPasskeyServicePublicKeyCredentialRequestOptions
});

export const vPasskeyServiceRegistrationCredential = v.object({
  id: v.string(),
  type: v.string(),
  response: vPasskeyServiceAttestationResponse
});

export const vPasskeyServiceRegisterFinishRequest = v.object({
  state: v.string(),
  credential: vPasskeyServiceRegistrationCredential,
  name: v.nullish(v.string())
});

export const vPasskeyServiceRelyingParty = v.object({
  id: v.string(),
  name: v.string()
});

export const vPasskeyServiceUserEntity = v.object({
  id: v.string(),
  name: v.string(),
  displayName: v.string()
});

export const vPasskeyServicePublicKeyCredentialCreationOptions = v.object({
  challenge: v.string(),
  rp: vPasskeyServiceRelyingParty,
  user: vPasskeyServiceUserEntity,
  pubKeyCredParams: v.array(vPasskeyServicePubKeyCredParam),
  authenticatorSelection: vPasskeyServiceAuthenticatorSelection,
  attestation: v.string(),
  excludeCredentials: v.array(vPasskeyServiceCredentialDescriptor),
  timeout: v.pipe(
    v.union([v.number(), v.string(), v.bigint()]),
    v.transform(x => BigInt(x)),
    v.minValue(
      BigInt("-9223372036854775808"),
      "Invalid value: Expected int64 to be >= -9223372036854775808"
    ),
    v.maxValue(
      BigInt("9223372036854775807"),
      "Invalid value: Expected int64 to be <= 9223372036854775807"
    )
  )
});

export const vPasskeyServiceRegistrationChallenge = v.object({
  state: v.string(),
  publicKey: vPasskeyServicePublicKeyCredentialCreationOptions
});

export const vPosition = v.picklist([
  "topleft",
  "topright",
  "bottomleft",
  "bottomright"
]);

export const vProbability = v.picklist(["likely", "possible", "unlikely"]);

export const vPublicationChecklistItem = v.intersect([
  vAbstractPersistentObject,
  v.object({
    id: v.nullish(v.string()),
    publicationChannel: v.optional(v.string()),
    ok: v.optional(v.boolean()),
    problemDescription: v.optional(v.string())
  })
]);

export const vChecklistServiceChecklist = v.object({
  checklistId: v.string(),
  timestamp: v.pipe(v.string(), v.isoTimestamp()),
  checklistItems: v.array(vPublicationChecklistItem),
  user: v.string()
});

export const vPublicationStrategyType = v.picklist([
  "publish",
  "noMessages",
  "minimalCAAML"
]);

export const vPushSubscription = v.object({
  id: v.nullish(
    v.pipe(
      v.union([v.number(), v.string(), v.bigint()]),
      v.transform(x => BigInt(x)),
      v.minValue(
        BigInt("-9223372036854775808"),
        "Invalid value: Expected int64 to be >= -9223372036854775808"
      ),
      v.maxValue(
        BigInt("9223372036854775807"),
        "Invalid value: Expected int64 to be <= 9223372036854775807"
      )
    )
  ),
  subscribeDate: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  auth: v.optional(v.string()),
  p256dh: v.optional(v.string()),
  endpoint: v.optional(v.string()),
  language: v.optional(vLanguageCode),
  region: v.optional(v.string()),
  failedCount: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        "Invalid value: Expected int32 to be >= -2147483648"
      ),
      v.maxValue(
        2147483647,
        "Invalid value: Expected int32 to be <= 2147483647"
      )
    )
  )
});

export const vRecognizability = v.picklist([
  "very_easy",
  "easy",
  "hard",
  "very_hard"
]);

export const vRegionLanguageConfiguration = v.object({
  lang: v.optional(vLanguageCode),
  websiteName: v.optional(v.string()),
  warningServiceName: v.optional(v.string()),
  warningServiceEmail: v.optional(v.string()),
  url: v.optional(v.string()),
  urlWithDate: v.optional(v.string())
});

export const vRole = v.picklist([
  "SUPERADMIN",
  "ADMIN",
  "FORECASTER",
  "FOREMAN",
  "OBSERVER"
]);

/**
 * This class holds all information about a server instance.
 */
export const vServerInstance = v.object({
  id: v.nullish(
    v.pipe(
      v.union([v.number(), v.string(), v.bigint()]),
      v.transform(x => BigInt(x)),
      v.minValue(
        BigInt("-9223372036854775808"),
        "Invalid value: Expected int64 to be >= -9223372036854775808"
      ),
      v.maxValue(
        BigInt("9223372036854775807"),
        "Invalid value: Expected int64 to be <= 9223372036854775807"
      )
    )
  ),
  name: v.optional(v.string()),
  apiUrl: v.optional(v.string()),
  userName: v.optional(v.string()),
  password: v.optional(v.string()),
  externalServer: v.optional(v.boolean())
});

export const vServerInstanceServiceServerVersionInfo = v.object({
  version: v.string()
});

export const vSlopeGradient = v.picklist([
  "moderately_steep",
  "steep",
  "very_steep",
  "extremely_steep"
]);

export const vSnowpackPosition = v.picklist([
  "upper",
  "middle",
  "lower",
  "ground"
]);

export const vSnowpackStability = v.picklist([
  "good",
  "fair",
  "poor",
  "very_poor"
]);

export const vEawsMatrixInformation = v.object({
  dangerRating: v.optional(vDangerRating),
  dangerRatingModificator: v.optional(vDangerRatingModificator),
  avalancheSize: v.optional(vAvalancheSize),
  snowpackStability: v.optional(vSnowpackStability),
  frequency: v.optional(vFrequency),
  avalancheSizeValue: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        "Invalid value: Expected int32 to be >= -2147483648"
      ),
      v.maxValue(
        2147483647,
        "Invalid value: Expected int32 to be <= 2147483647"
      )
    )
  ),
  snowpackStabilityValue: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        "Invalid value: Expected int32 to be >= -2147483648"
      ),
      v.maxValue(
        2147483647,
        "Invalid value: Expected int32 to be <= 2147483647"
      )
    )
  ),
  frequencyValue: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        "Invalid value: Expected int32 to be >= -2147483648"
      ),
      v.maxValue(
        2147483647,
        "Invalid value: Expected int32 to be <= 2147483647"
      )
    )
  )
});

export const vAvalancheProblem = v.intersect([
  vAbstractPersistentObject,
  v.object({
    id: v.nullish(v.string()),
    avalancheType: v.optional(vAvalancheType),
    avalancheProblem: v.optional(vAvalancheProblem1),
    aspects: v.optional(v.array(vAspect)),
    elevationHigh: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(
          -2147483648,
          "Invalid value: Expected int32 to be >= -2147483648"
        ),
        v.maxValue(
          2147483647,
          "Invalid value: Expected int32 to be <= 2147483647"
        )
      )
    ),
    treelineHigh: v.optional(v.boolean()),
    elevationLow: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(
          -2147483648,
          "Invalid value: Expected int32 to be >= -2147483648"
        ),
        v.maxValue(
          2147483647,
          "Invalid value: Expected int32 to be <= 2147483647"
        )
      )
    ),
    treelineLow: v.optional(v.boolean()),
    dangerRatingDirection: v.optional(vDirection),
    matrixInformation: v.optional(vMatrixInformation),
    eawsMatrixInformation: v.optional(vEawsMatrixInformation)
  })
]);

export const vAvalancheBulletinDaytimeDescription = v.intersect([
  vAbstractPersistentObject,
  v.object({
    id: v.nullish(v.string()),
    warningLevelId: v.optional(v.string()),
    hasElevationDependency: v.optional(v.boolean()),
    elevation: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(
          -2147483648,
          "Invalid value: Expected int32 to be >= -2147483648"
        ),
        v.maxValue(
          2147483647,
          "Invalid value: Expected int32 to be <= 2147483647"
        )
      )
    ),
    treeline: v.optional(v.boolean()),
    dangerRatingAbove: v.optional(vDangerRating),
    dangerRatingBelow: v.optional(vDangerRating),
    complexity: v.optional(vComplexity),
    avalancheProblem1: v.nullish(vAvalancheProblem),
    avalancheProblem2: v.nullish(vAvalancheProblem),
    avalancheProblem3: v.nullish(vAvalancheProblem),
    avalancheProblem4: v.nullish(vAvalancheProblem),
    avalancheProblem5: v.nullish(vAvalancheProblem)
  })
]);

export const vStatusInformation = v.object({
  ok: v.boolean(),
  title: v.string(),
  message: v.string()
});

export const vStrategicMindset = v.picklist([
  "assessment",
  "stepping_out",
  "status_quo",
  "stepping_back",
  "entrenchment",
  "free_ride",
  "high_alert",
  "spring_diurnal"
]);

export const vStressLevel = v.object({
  date: v.optional(v.pipe(v.string(), v.isoDate())),
  stressLevel: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        "Invalid value: Expected int32 to be >= -2147483648"
      ),
      v.maxValue(
        2147483647,
        "Invalid value: Expected int32 to be <= 2147483647"
      )
    )
  ),
  lastUpdated: v.optional(v.pipe(v.string(), v.isoTimestamp()))
});

export const vSubscriptionServiceEmailSubscription = v.object({
  email: v.string(),
  regions: v.string(),
  language: vLanguageCode
});

export const vTendency = v.picklist(["decreasing", "steady", "increasing"]);

export const vTendencyProgression = v.object({
  dates: v.optional(v.array(v.pipe(v.string(), v.isoTimestamp()))),
  dangerRatings: v.optional(v.record(v.string(), v.array(vDangerRating)))
});

export const vTerrainType = v.picklist([
  "gullies_and_bowls",
  "adjacent_to_ridgelines",
  "distant_from_ridgelines",
  "in_the_vicinity_of_peaks",
  "pass_areas",
  "shady_slopes",
  "sunny_slopes",
  "grassy_slopes",
  "cut_slopes",
  "wind_loaded_slopes",
  "base_of_rock_walls",
  "behind_abrupt_changes_in_the_terrain",
  "transitions_into_gullies_and_bowls",
  "areas_where_the_snow_cover_is_rather_shallow",
  "transitions_from_a_shallow_to_a_deep_snowpack",
  "highly_frequented_off_piste_terrain",
  "little_used_backcountry_terrain",
  "places_that_are_protected_from_the_wind",
  "regions_exposed_to_the_foehn_wind",
  "regions_with_a_lot_of_snow",
  "regions_exposed_to_precipitation",
  "regions_exposed_to_heavier_precipitation"
]);

export const vTextPart = v.picklist([
  "generalHeadlineComment",
  "highlights",
  "avActivityHighlights",
  "avActivityComment",
  "snowpackStructureHighlights",
  "snowpackStructureComment",
  "synopsisHighlights",
  "synopsisComment",
  "tendencyComment",
  "travelAdvisoryHighlights",
  "travelAdvisoryComment"
]);

/**
 * This class holds all information about one region.
 */
export const vRegion = v.object({
  id: v.optional(v.string()),
  microRegions: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        "Invalid value: Expected int32 to be >= -2147483648"
      ),
      v.maxValue(
        2147483647,
        "Invalid value: Expected int32 to be <= 2147483647"
      )
    )
  ),
  subRegions: v.optional(v.array(v.string())),
  superRegions: v.optional(v.array(v.string())),
  neighborRegions: v.optional(v.array(v.string())),
  languageConfigurations: v.optional(v.array(vRegionLanguageConfiguration)),
  staticUrl: v.optional(v.string()),
  enabledLanguages: v.optional(v.array(vLanguageCode)),
  ttsLanguages: v.optional(v.array(vLanguageCode)),
  publishBulletins: v.optional(v.boolean()),
  publishBlogs: v.optional(v.boolean()),
  createCaamlV6: v.optional(v.boolean()),
  createJson: v.optional(v.boolean()),
  createMaps: v.optional(v.boolean()),
  createPdf: v.optional(v.boolean()),
  createSimpleHtml: v.optional(v.boolean()),
  sendEmails: v.optional(v.boolean()),
  sendTelegramMessages: v.optional(v.boolean()),
  sendWhatsAppMessages: v.optional(v.boolean()),
  sendPushNotifications: v.optional(v.boolean()),
  enableMediaFile: v.optional(v.boolean()),
  enableIcon: v.optional(v.boolean()),
  enableAvalancheProblemCornices: v.optional(v.boolean()),
  enableAvalancheProblemNoDistinctAvalancheProblem: v.optional(v.boolean()),
  showMatrix: v.optional(v.boolean()),
  enableStrategicMindset: v.optional(v.boolean()),
  enableStressLevel: v.optional(v.boolean()),
  pdfColor: v.optional(v.string()),
  emailColor: v.optional(v.string()),
  pdfMapYAmPm: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        "Invalid value: Expected int32 to be >= -2147483648"
      ),
      v.maxValue(
        2147483647,
        "Invalid value: Expected int32 to be <= 2147483647"
      )
    )
  ),
  pdfMapYFd: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        "Invalid value: Expected int32 to be >= -2147483648"
      ),
      v.maxValue(
        2147483647,
        "Invalid value: Expected int32 to be <= 2147483647"
      )
    )
  ),
  pdfMapWidthAmPm: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        "Invalid value: Expected int32 to be >= -2147483648"
      ),
      v.maxValue(
        2147483647,
        "Invalid value: Expected int32 to be <= 2147483647"
      )
    )
  ),
  pdfMapWidthFd: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        "Invalid value: Expected int32 to be >= -2147483648"
      ),
      v.maxValue(
        2147483647,
        "Invalid value: Expected int32 to be <= 2147483647"
      )
    )
  ),
  pdfMapHeight: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(
        -2147483648,
        "Invalid value: Expected int32 to be >= -2147483648"
      ),
      v.maxValue(
        2147483647,
        "Invalid value: Expected int32 to be <= 2147483647"
      )
    )
  ),
  pdfFooterLogo: v.optional(v.boolean()),
  pdfFooterLogoColorPath: v.optional(v.string()),
  pdfFooterLogoBwPath: v.optional(v.string()),
  geoDataDirectory: v.optional(v.string()),
  mapLogoPosition: v.optional(vPosition),
  imageColorbarColorPath: v.optional(v.string()),
  imageColorbarBwPath: v.optional(v.string()),
  enableDangerSources: v.optional(v.boolean()),
  enableObservations: v.optional(v.boolean()),
  enableIncidents: v.optional(v.boolean()),
  enableModelling: v.optional(v.boolean()),
  enabledTextcatFields: v.optional(v.array(vTextPart)),
  enabledEditableFields: v.optional(v.array(vTextPart)),
  enableLineaExport: v.optional(v.boolean()),
  defaultLang: v.optional(vLanguageCode),
  logoPath: v.optional(v.string()),
  logoBwPath: v.optional(v.string()),
  coatOfArms: v.optional(v.string()),
  serverImagesUrl: v.optional(v.string()),
  educationUrl: v.optional(v.string()),
  awsomeUrl: v.optional(v.string())
});

export const vThickness = v.picklist(["thick", "thin"]);

export const vUser = v.object({
  email: v.optional(v.string()),
  password: v.optional(v.string()),
  name: v.optional(v.string()),
  roles: v.optional(v.array(vRole)),
  regions: v.optional(v.array(v.string())),
  image: v.optional(v.string()),
  organization: v.optional(v.string()),
  languageCode: v.optional(vLanguageCode),
  deleted: v.optional(v.boolean()),
  lastUsedAt: v.optional(v.pipe(v.string(), v.isoTimestamp()))
});

export const vAuthenticationServiceAuthenticationResponse = v.object({
  user: vUser,
  regions: v.array(vRegion),
  access_token: v.string()
});

/**
 * This class holds all information about one avalanche bulletin.
 */
export const vAvalancheBulletin = v.intersect([
  vAbstractPersistentObject,
  v.object({
    id: v.nullish(v.string()),
    author: v.nullish(vUser),
    additionalAuthors: v.optional(v.array(v.string())),
    updateDate: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    ownerRegion: v.optional(v.string()),
    highlightsTextcat: v.optional(v.string()),
    avActivityHighlightsTextcat: v.optional(v.string()),
    avActivityCommentTextcat: v.optional(v.string()),
    snowpackStructureHighlightsTextcat: v.optional(v.string()),
    snowpackStructureCommentTextcat: v.optional(v.string()),
    tendencyCommentTextcat: v.optional(v.string()),
    generalHeadlineCommentTextcat: v.optional(v.string()),
    synopsisCommentTextcat: v.optional(v.string()),
    avActivityHighlightsNotes: v.optional(v.string()),
    avActivityCommentNotes: v.optional(v.string()),
    snowpackStructureHighlightsNotes: v.optional(v.string()),
    snowpackStructureCommentNotes: v.optional(v.string()),
    tendencyCommentNotes: v.optional(v.string()),
    generalHeadlineCommentNotes: v.optional(v.string()),
    highlights: v.optional(v.array(vAvalancheBulletinText)),
    avActivityHighlights: v.optional(v.array(vAvalancheBulletinText)),
    avActivityComment: v.optional(v.array(vAvalancheBulletinText)),
    synopsisHighlights: v.optional(v.array(vAvalancheBulletinText)),
    synopsisComment: v.optional(v.array(vAvalancheBulletinText)),
    snowpackStructureHighlights: v.optional(v.array(vAvalancheBulletinText)),
    snowpackStructureComment: v.optional(v.array(vAvalancheBulletinText)),
    travelAdvisoryHighlights: v.optional(v.array(vAvalancheBulletinText)),
    travelAdvisoryComment: v.optional(v.array(vAvalancheBulletinText)),
    tendencyComment: v.optional(v.array(vAvalancheBulletinText)),
    generalHeadlineComment: v.optional(v.array(vAvalancheBulletinText)),
    tendency: v.optional(vTendency),
    dangerPattern1: v.optional(vDangerPattern),
    dangerPattern2: v.optional(vDangerPattern),
    publicationDate: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    validity: v.optional(vAvalancheBulletinValidity),
    suggestedRegions: v.optional(v.array(v.string())),
    savedRegions: v.optional(v.array(v.string())),
    savedOrPublishedRegions: v.optional(v.array(v.string())),
    regions: v.optional(v.array(v.string())),
    publishedRegions: v.optional(v.array(v.string())),
    strategicMindset: v.optional(vStrategicMindset),
    forenoon: v.nullish(vAvalancheBulletinDaytimeDescription),
    afternoon: v.nullish(vAvalancheBulletinDaytimeDescription),
    photos: v.optional(v.array(vAvalancheBulletinPhoto)),
    hasDaytimeDependency: v.optional(v.boolean())
  })
]);

export const vUserServiceChangePassword = v.object({
  oldPassword: v.string(),
  newPassword: v.string()
});

export const vUserServiceCheckPassword = v.object({
  password: v.string()
});

export const vUserServiceResetPassword = v.object({
  newPassword: v.string()
});

export const vWeatherStationsFeatureType = v.picklist(["Feature"]);

export const vWeatherStationsFeatureCollectionType = v.picklist([
  "FeatureCollection"
]);

export const vWeatherStationsGeometryType = v.picklist(["Point"]);

export const vWeatherStationsGeometry = v.object({
  coordinates: v.optional(v.array(v.number())),
  type: vWeatherStationsGeometryType
});

export const vWeatherStationsStatistics = v.object({
  average: v.number(),
  count: v.number(),
  delta: v.number(),
  max: v.number(),
  median: v.number(),
  min: v.number(),
  sum: v.number(),
  unit: v.optional(
    v.picklist([
      "K",
      "℃",
      "m",
      "cm",
      "mm",
      "1",
      "%",
      "°",
      "m/s",
      "km/h",
      "hPa",
      "Pa",
      "W/m²"
    ])
  )
});

/**
 * The properties of a weather station including measured values
 */
export const vWeatherStationsProperties = v.object({
  altitude: v.optional(v.number()),
  dataProviderID: v.string(),
  dataURLs: v.optional(v.array(v.string())),
  date: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  DW: v.optional(v.number()),
  HS: v.optional(v.number()),
  HSD_24: v.optional(v.number()),
  HSD_48: v.optional(v.number()),
  HSD_6: v.optional(v.number()),
  HSD_72: v.optional(v.number()),
  ILWR: v.optional(v.number()),
  ISWR: v.optional(v.number()),
  microRegionID: v.optional(v.string()),
  name: v.optional(v.string()),
  OLWR: v.optional(v.number()),
  operator: v.optional(v.string()),
  operatorLicense: v.optional(v.string()),
  operatorLicenseLink: v.optional(v.pipe(v.string(), v.url())),
  operatorLink: v.optional(v.pipe(v.string(), v.url())),
  P: v.optional(v.number()),
  plot: v.optional(v.string()),
  PSUM_24: v.optional(v.number()),
  PSUM_48: v.optional(v.number()),
  PSUM_6: v.optional(v.number()),
  PSUM_72: v.optional(v.number()),
  RH: v.optional(v.number()),
  RSWR: v.optional(v.number()),
  shortName: v.optional(v.pipe(v.string(), v.regex(/^[A-Za-z0-9]+$/))),
  startYear: v.optional(v.string()),
  stationCharacteristics: v.optional(v.string()),
  statistics: v.object({}),
  TA: v.optional(v.number()),
  TA_MAX: v.optional(v.number()),
  TA_MIN: v.optional(v.number()),
  TD: v.optional(v.number()),
  TSS: v.optional(v.number()),
  VW: v.optional(v.number()),
  VW_MAX: v.optional(v.number())
});

/**
 * A GeoJSON Feature corresponding to one weather station
 */
export const vWeatherStationsFeature = v.object({
  geometry: vWeatherStationsGeometry,
  id: v.optional(v.string()),
  properties: vWeatherStationsProperties,
  type: vWeatherStationsFeatureType
});

/**
 * A GeoJSON FeatureCollection of weather stations
 */
export const vWeatherStationsFeatureCollection = v.object({
  features: v.array(vWeatherStationsFeature),
  properties: v.record(v.string(), v.unknown()),
  type: vWeatherStationsFeatureCollectionType
});

export const vWetness = v.picklist(["wet", "moist", "dry"]);

/**
 * This class holds all information about one danger source variant.
 */
export const vDangerSourceVariant = v.intersect([
  vAbstractPersistentObject,
  v.object({
    id: v.nullish(v.string()),
    originalDangerSourceVariantId: v.optional(v.string()),
    forecastDangerSourceVariantId: v.optional(v.string()),
    dangerSource: v.nullish(vDangerSource),
    title: v.optional(v.string()),
    creationDate: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    updateDate: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    validFrom: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    validUntil: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    dangerSourceVariantStatus: v.optional(vDangerSourceVariantStatus),
    dangerSourceVariantType: v.optional(vDangerSourceVariantType),
    ownerRegion: v.optional(v.string()),
    regions: v.optional(v.array(v.string())),
    hasDaytimeDependency: v.optional(v.boolean()),
    avalancheType: v.optional(vAvalancheType),
    aspects: v.optional(v.array(vAspect)),
    elevationHigh: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(
          -2147483648,
          "Invalid value: Expected int32 to be >= -2147483648"
        ),
        v.maxValue(
          2147483647,
          "Invalid value: Expected int32 to be <= 2147483647"
        )
      )
    ),
    treelineHigh: v.optional(v.boolean()),
    elevationLow: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(
          -2147483648,
          "Invalid value: Expected int32 to be >= -2147483648"
        ),
        v.maxValue(
          2147483647,
          "Invalid value: Expected int32 to be <= 2147483647"
        )
      )
    ),
    treelineLow: v.optional(v.boolean()),
    aspectsOfExistence: v.optional(v.array(vAspect)),
    elevationHighOfExistence: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(
          -2147483648,
          "Invalid value: Expected int32 to be >= -2147483648"
        ),
        v.maxValue(
          2147483647,
          "Invalid value: Expected int32 to be <= 2147483647"
        )
      )
    ),
    treelineHighOfExistence: v.optional(v.boolean()),
    elevationLowOfExistence: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(
          -2147483648,
          "Invalid value: Expected int32 to be >= -2147483648"
        ),
        v.maxValue(
          2147483647,
          "Invalid value: Expected int32 to be <= 2147483647"
        )
      )
    ),
    treelineLowOfExistence: v.optional(v.boolean()),
    dangerIncreaseWithElevation: v.optional(v.boolean()),
    highestDangerAspect: v.optional(vAspect),
    dangerPeak: v.optional(vDaytime),
    slopeGradient: v.optional(vSlopeGradient),
    runoutIntoGreen: v.optional(v.boolean()),
    penetrateDeepLayers: v.optional(v.boolean()),
    naturalRelease: v.optional(vProbability),
    dangerSigns: v.optional(v.array(vDangerSign)),
    eawsMatrixInformation: v.optional(vEawsMatrixInformation),
    comment: v.optional(v.string()),
    textcat: v.optional(v.string()),
    uncertainty: v.optional(v.string()),
    glidingSnowActivity: v.optional(vGlidingSnowActivity),
    glidingSnowActivityValue: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(
          -2147483648,
          "Invalid value: Expected int32 to be >= -2147483648"
        ),
        v.maxValue(
          2147483647,
          "Invalid value: Expected int32 to be <= 2147483647"
        )
      )
    ),
    snowHeightUpperLimit: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(
          -2147483648,
          "Invalid value: Expected int32 to be >= -2147483648"
        ),
        v.maxValue(
          2147483647,
          "Invalid value: Expected int32 to be <= 2147483647"
        )
      )
    ),
    snowHeightLowerLimit: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(
          -2147483648,
          "Invalid value: Expected int32 to be >= -2147483648"
        ),
        v.maxValue(
          2147483647,
          "Invalid value: Expected int32 to be <= 2147483647"
        )
      )
    ),
    snowHeightAverage: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(
          -2147483648,
          "Invalid value: Expected int32 to be >= -2147483648"
        ),
        v.maxValue(
          2147483647,
          "Invalid value: Expected int32 to be <= 2147483647"
        )
      )
    ),
    zeroDegreeIsotherm: v.optional(v.boolean()),
    slabGrainShape: v.optional(vGrainShape),
    slabThicknessUpperLimit: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(
          -2147483648,
          "Invalid value: Expected int32 to be >= -2147483648"
        ),
        v.maxValue(
          2147483647,
          "Invalid value: Expected int32 to be <= 2147483647"
        )
      )
    ),
    slabThicknessLowerLimit: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(
          -2147483648,
          "Invalid value: Expected int32 to be >= -2147483648"
        ),
        v.maxValue(
          2147483647,
          "Invalid value: Expected int32 to be <= 2147483647"
        )
      )
    ),
    slabHandHardnessUpperLimit: v.optional(vHandHardness),
    slabHandHardnessLowerLimit: v.optional(vHandHardness),
    slabHardnessProfile: v.optional(vTendency),
    slabEnergyTransferPotential: v.optional(vCharacteristic),
    slabDistribution: v.optional(vDistribution),
    weakLayerGrainShapes: v.optional(v.array(vGrainShape)),
    weakLayerGrainSizeUpperLimit: v.optional(v.number()),
    weakLayerGrainSizeLowerLimit: v.optional(v.number()),
    weakLayerPersistent: v.optional(v.boolean()),
    weakLayerThickness: v.optional(vThickness),
    weakLayerStrength: v.optional(vCharacteristic),
    weakLayerWet: v.optional(v.boolean()),
    weakLayerCrustAbove: v.optional(vCrust),
    weakLayerCrustBelow: v.optional(vCrust),
    weakLayerPosition: v.optional(vSnowpackPosition),
    weakLayerCreation: v.optional(vCreationProcess),
    weakLayerDistribution: v.optional(vDistribution),
    dangerSpotRecognizability: v.optional(vRecognizability),
    remoteTriggering: v.optional(vProbability),
    terrainTypes: v.optional(v.array(vTerrainType)),
    looseSnowGrainShape: v.optional(vGrainShape),
    looseSnowMoisture: v.optional(vWetness)
  })
]);

/**
 * Date of validity in the format yyyy-MM-dd
 */
export const vStaticDate = v.pipe(v.string(), v.isoDate());

/**
 * Timestamp of the hourly snapshot in the format yyyy-MM-dd_HH-mm
 */
export const vStaticDateTime = v.string();

/**
 * Publication timestamp in the format yyyy-MM-dd_HH-mm-ss
 */
export const vStaticPublication = v.string();

/**
 * Region ID, e.g. `EUREGIO`, `AT-07`, `IT-32-BZ`, `IT-32-TN`
 */
export const vStaticRegion = v.string();

export const vStaticLang = vLanguageCode;

/**
 * index 200 response
 */
export const vIndexResponse = v.string();

export const vLoginBody = vAuthenticationServiceCredentials;

/**
 * login 200 response
 */
export const vLoginResponse = vAuthenticationServiceAuthenticationResponse;

/**
 * listPasskeys 200 response
 */
export const vListPasskeysResponse = v.array(vPasskeyServicePasskeyInfo);

export const vFinishLoginBody = vPasskeyServiceLoginFinishRequest;

/**
 * finishLogin 200 response
 */
export const vFinishLoginResponse =
  vAuthenticationServiceAuthenticationResponse;

export const vBeginLoginBody = vPasskeyServiceLoginBeginRequest;

/**
 * beginLogin 200 response
 */
export const vBeginLoginResponse = vPasskeyServiceLoginChallenge;

export const vFinishRegistrationBody = vPasskeyServiceRegisterFinishRequest;

/**
 * finishRegistration 200 response
 */
export const vFinishRegistrationResponse = vPasskeyServicePasskeyInfo;

/**
 * beginRegistration 200 response
 */
export const vBeginRegistrationResponse = vPasskeyServiceRegistrationChallenge;

export const vDeletePasskeyPath = v.object({
  id: v.string()
});

/**
 * testAuth 200 response
 */
export const vTestAuthResponse = vAuthenticationServiceUsername;

export const vGetBlogPostQuery = v.object({
  region: v.optional(v.string(), "AT-07"),
  lang: v.optional(vLanguageCode),
  id: v.string()
});

/**
 * getBlogPost 200 response
 */
export const vGetBlogPostResponse = vBlogItem;

export const vGetBlogPostsQuery = v.object({
  region: v.optional(v.string(), "AT-07"),
  lang: v.optional(vLanguageCode),
  searchText: v.string(),
  searchCategory: v.string(),
  startDate: v.string(),
  endDate: v.string()
});

/**
 * getBlogPosts 200 response
 */
export const vGetBlogPostsResponse = v.array(vBlogItem);

export const vSendLatestBlogPostQuery = v.object({
  region: v.string(),
  lang: vLanguageCode
});

export const vSendLatestBlogPostEmailQuery = v.object({
  region: v.string(),
  lang: vLanguageCode
});

export const vSendLatestBlogPostPushQuery = v.object({
  region: v.string(),
  lang: vLanguageCode
});

export const vSendLatestBlogPostTelegramQuery = v.object({
  region: v.string(),
  lang: vLanguageCode
});

export const vSendLatestBlogPostWhatsAppQuery = v.object({
  region: v.string(),
  lang: vLanguageCode
});

export const vGetPublishedJsonBulletins0Query = v.object({
  version: v.optional(vCaamlVersion),
  regions: v.array(v.string()),
  region: v.string(),
  lang: vLanguageCode,
  date: v.string()
});

/**
 * bulletins
 */
export const vGetPublishedJsonBulletins0Response = v.array(vAvalancheBulletin);

export const vCreateJsonBulletinsBody = v.array(vAvalancheBulletin);

export const vCreateJsonBulletinsQuery = v.object({
  date: v.string(),
  region: v.string()
});

/**
 * createJSONBulletins 200 response
 */
export const vCreateJsonBulletinsResponse = v.array(vAvalancheBulletin);

export const vCreateJsonBulletinBody = vAvalancheBulletin;

export const vCreateJsonBulletinQuery = v.object({
  date: v.string(),
  region: v.string()
});

/**
 * createJSONBulletin 200 response
 */
export const vCreateJsonBulletinResponse = v.array(vAvalancheBulletin);

export const vGetPublishedCaamlBulletinsQuery = v.object({
  date: v.string(),
  regions: v.array(v.string()),
  lang: v.optional(vLanguageCode),
  version: v.optional(vCaamlVersion)
});

/**
 * CAAML XML bulletins
 */
export const vGetPublishedCaamlBulletinsResponse = vCaamlAvalancheBulletins;

export const vGetPublishedCaamlJsonBulletinsQuery = v.object({
  date: v.string(),
  regions: v.array(v.string()),
  lang: vLanguageCode,
  version: v.optional(vCaamlVersion)
});

/**
 * CAAML JSON bulletins
 */
export const vGetPublishedCaamlJsonBulletinsResponse = vCaamlAvalancheBulletins;

export const vCheckBulletinsQuery = v.object({
  region: v.string(),
  date: v.string()
});

/**
 * checkBulletins 200 response
 */
export const vCheckBulletinsResponse = v.array(v.string());

export const vGetJsonBulletinsQuery = v.object({
  date: v.string(),
  regions: v.array(v.string())
});

/**
 * bulletins
 */
export const vGetJsonBulletinsResponse = v.array(vAvalancheBulletin);

export const vGetCaamlJsonBulletinsQuery = v.object({
  date: v.string(),
  regions: v.array(v.string()),
  lang: vLanguageCode,
  version: v.optional(vCaamlVersion)
});

/**
 * CAAML JSON bulletins
 */
export const vGetCaamlJsonBulletinsResponse = vCaamlAvalancheBulletins;

export const vGetHighestDangerRatingQuery = v.object({
  date: v.string(),
  regions: v.array(v.string())
});

/**
 * latest
 */
export const vGetHighestDangerRatingResponse = vAvalancheBulletinServiceHighest;

export const vGetPublishedJsonBulletinsQuery = v.object({
  date: v.string(),
  regions: v.array(v.string()),
  lang: vLanguageCode
});

/**
 * bulletins
 */
export const vGetPublishedJsonBulletinsResponse = v.array(vAvalancheBulletin);

/**
 * getLatest 200 response
 */
export const vGetLatestResponse = vAvalancheBulletinServiceLatestBulletin;

export const vGetPublishedBulletinsAsPdfQuery = v.object({
  date: v.string(),
  bulletinId: v.nullish(v.string()),
  microRegionId: v.nullish(v.string()),
  region: v.string(),
  grayscale: v.boolean(),
  lang: vLanguageCode
});

/**
 * getPublishedBulletinsAsPDF 200 response
 */
export const vGetPublishedBulletinsAsPdfResponse = v.string();

export const vUploadBulletinPhotoBody = v.object({
  file: v.optional(v.string())
});

export const vUploadBulletinPhotoQuery = v.object({
  region: v.string()
});

/**
 * uploadBulletinPhoto 200 response
 */
export const vUploadBulletinPhotoResponse =
  vCaamlAvalancheBulletinCustomDataBulletinPhoto;

export const vGetPreviewPdfBody = v.array(vAvalancheBulletin);

export const vGetPreviewPdfQuery = v.object({
  region: v.string(),
  lang: vLanguageCode
});

/**
 * getPreviewPdf 200 response
 */
export const vGetPreviewPdfResponse = v.string();

export const vPublishBulletinsQuery = v.object({
  region: v.string(),
  strategy: v.optional(vPublicationStrategyType),
  date: v.string()
});

export const vPublishAllBulletinsQuery = v.object({
  date: v.string(),
  strategy: v.optional(vPublicationStrategyType)
});

export const vSendEmailQuery = v.object({
  region: v.string(),
  date: v.string(),
  lang: v.nullish(vLanguageCode)
});

export const vTriggerPushNotificationsQuery = v.object({
  region: v.string(),
  date: v.string(),
  lang: v.nullish(vLanguageCode)
});

export const vTriggerTelegramChannelQuery = v.object({
  region: v.string(),
  date: v.string(),
  lang: v.nullish(vLanguageCode)
});

export const vTriggerWhatsAppChannelQuery = v.object({
  region: v.string(),
  date: v.string(),
  lang: v.nullish(vLanguageCode)
});

export const vGetStatusQuery = v.object({
  region: v.string(),
  timezone: v.string(),
  startDate: v.string(),
  endDate: v.string()
});

/**
 * getStatus 200 response
 */
export const vGetStatusResponse = v.array(
  vAvalancheBulletinStatusServiceStatus
);

export const vGetInternalStatusQuery = v.object({
  region: v.string(),
  startDate: v.string(),
  endDate: v.string()
});

/**
 * getInternalStatus 200 response
 */
export const vGetInternalStatusResponse = v.array(
  vAvalancheBulletinStatusServiceStatus
);

export const vGetPublicationStatusQuery = v.object({
  region: v.string(),
  date: v.string()
});

/**
 * getPublicationStatus 200 response
 */
export const vGetPublicationStatusResponse =
  vAvalancheBulletinStatusServiceStatus;

export const vSubmitBulletinsQuery = v.object({
  region: v.string(),
  date: v.string()
});

export const vGetTendencyQuery = v.object({
  date: v.string(),
  region: v.nullish(v.string())
});

/**
 * tendency of each micro region with published bulletins
 */
export const vGetTendencyResponse = vTendencyProgression;

export const vDeleteJsonBulletinPath = v.object({
  bulletinId: v.string()
});

export const vDeleteJsonBulletinQuery = v.object({
  date: v.string(),
  region: v.string()
});

/**
 * deleteJSONBulletin 200 response
 */
export const vDeleteJsonBulletinResponse = v.array(vAvalancheBulletin);

export const vGetJsonBulletinPath = v.object({
  bulletinId: v.string()
});

/**
 * bulletin
 */
export const vGetJsonBulletinResponse = vAvalancheBulletin;

export const vUpdateJsonBulletinBody = vAvalancheBulletin;

export const vUpdateJsonBulletinPath = v.object({
  bulletinId: v.string()
});

export const vUpdateJsonBulletinQuery = v.object({
  date: v.string(),
  region: v.string()
});

/**
 * updateJSONBulletin 200 response
 */
export const vUpdateJsonBulletinResponse = v.array(vAvalancheBulletin);

export const vGetChecklistsQuery = v.object({
  date: v.string(),
  region: v.string()
});

/**
 * getChecklists 200 response
 */
export const vGetChecklistsResponse = v.array(vChecklistServiceChecklist);

export const vSaveChecklistBody = vChecklistServiceChecklist;

export const vSaveChecklistQuery = v.object({
  date: v.string(),
  region: v.string()
});

/**
 * saveChecklist 200 response
 */
export const vSaveChecklistResponse = vChecklistServiceChecklist;

export const vGetDangerSourcesQuery = v.object({
  date: v.string(),
  region: v.string()
});

/**
 * danger-sources
 */
export const vGetDangerSourcesResponse = v.array(vDangerSource);

export const vSaveDangerSourceBody = vDangerSource;

/**
 * saveDangerSource 200 response
 */
export const vSaveDangerSourceResponse = vDangerSource;

export const vGetVariantsQuery = v.object({
  date: v.string(),
  region: v.string()
});

/**
 * danger-sources
 */
export const vGetVariantsResponse = v.array(vDangerSourceVariant);

export const vGetInternalStatus1Query = v.object({
  region: v.string(),
  startDate: v.string(),
  endDate: v.string()
});

/**
 * getInternalStatus_1 200 response
 */
export const vGetInternalStatus1Response = v.array(vDangerSourceVariantsStatus);

export const vSaveDangerSourceVariantBody = vDangerSourceVariant;

export const vSaveDangerSourceVariantQuery = v.object({
  date: v.string(),
  region: v.string()
});

/**
 * saveDangerSourceVariant 200 response
 */
export const vSaveDangerSourceVariantResponse = vDangerSourceVariant;

export const vReplaceVariantsBody = v.array(vDangerSourceVariant);

export const vReplaceVariantsQuery = v.object({
  date: v.string(),
  region: v.string()
});

/**
 * replaceVariants 200 response
 */
export const vReplaceVariantsResponse = v.array(vDangerSourceVariant);

export const vDeleteVariantPath = v.object({
  variantId: v.string()
});

export const vDeleteVariantQuery = v.object({
  date: v.string(),
  region: v.string()
});

/**
 * deleteVariant 200 response
 */
export const vDeleteVariantResponse = v.array(vDangerSourceVariant);

export const vGetVariantByIdPath = v.object({
  variantId: v.string()
});

/**
 * variant
 */
export const vGetVariantByIdResponse = vDangerSourceVariant;

export const vGetVariantsForDangerSourcePath = v.object({
  dangerSourceId: v.string()
});

export const vGetVariantsForDangerSourceQuery = v.object({
  date: v.string(),
  region: v.string()
});

/**
 * danger-sources
 */
export const vGetVariantsForDangerSourceResponse =
  v.array(vDangerSourceVariant);

export const vAddSubscriberBody = vSubscriptionServiceEmailSubscription;

export const vGetIncidentsQuery = v.object({
  region: v.string(),
  seasonYear: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(
      -2147483648,
      "Invalid value: Expected int32 to be >= -2147483648"
    ),
    v.maxValue(2147483647, "Invalid value: Expected int32 to be <= 2147483647")
  ),
  startDate: v.nullish(v.string()),
  endDate: v.nullish(v.string())
});

/**
 * OK response
 */
export const vGetIncidentsResponse = v.array(vIncidentsIncidentSchema);

export const vCreateIncidentBody = v.string();

export const vCreateIncidentQuery = v.object({
  region: v.string()
});

/**
 * createIncident 200 response
 */
export const vCreateIncidentResponse = vIncident;

export const vDeleteIncidentPath = v.object({
  id: v.pipe(v.string(), v.uuid())
});

export const vGetIncidentPath = v.object({
  id: v.pipe(v.string(), v.uuid())
});

/**
 * OK response
 */
export const vGetIncidentResponse = vIncidentsIncidentSchema;

export const vUpdateIncidentBody = v.string();

export const vUpdateIncidentPath = v.object({
  id: v.pipe(v.string(), v.uuid())
});

/**
 * updateIncident 200 response
 */
export const vUpdateIncidentResponse = vIncident;

export const vUploadIncidentAttachmentBody = v.object({
  file: v.optional(v.string())
});

export const vUploadIncidentAttachmentPath = v.object({
  id: v.pipe(v.string(), v.uuid())
});

/**
 * uploadIncidentAttachment 200 response
 */
export const vUploadIncidentAttachmentResponse = vIncidentAttachment;

export const vDeleteIncidentAttachmentPath = v.object({
  id: v.pipe(v.string(), v.uuid()),
  attachmentId: v.pipe(v.string(), v.uuid())
});

export const vGetIncidentAttachmentPath = v.object({
  id: v.pipe(v.string(), v.uuid()),
  attachmentId: v.pipe(v.string(), v.uuid())
});

/**
 * getIncidentAttachment 200 response
 */
export const vGetIncidentAttachmentResponse = v.string();

export const vUnpublishIncidentPath = v.object({
  id: v.pipe(v.string(), v.uuid())
});

/**
 * unpublishIncident 200 response
 */
export const vUnpublishIncidentResponse = vIncident;

export const vPublishIncidentBody = v.string();

export const vPublishIncidentPath = v.object({
  id: v.pipe(v.string(), v.uuid())
});

/**
 * publishIncident 200 response
 */
export const vPublishIncidentResponse = vIncident;

export const vSaveMediaFileBody = v.object({
  text: v.optional(v.string()),
  file: v.optional(v.string())
});

export const vSaveMediaFileQuery = v.object({
  date: v.string(),
  region: v.string(),
  lang: vLanguageCode,
  important: v.boolean()
});

export const vGetRssFeedQuery = v.object({
  region: v.optional(v.string(), "AT-07"),
  lang: v.optional(vLanguageCode)
});

/**
 * getRssFeed 200 response
 */
export const vGetRssFeedResponse = v.string();

export const vDeleteGenericObservationBody = vGenericObservation;

export const vGetGenericObservationsQuery = v.object({
  startDate: v.string(),
  endDate: v.string()
});

/**
 * getGenericObservations 200 response
 */
export const vGetGenericObservationsResponse = v.array(vGenericObservation);

export const vSaveOrUpdateGenericObservationBody = vGenericObservation;

export const vGetGenericObservationQuery = v.object({
  source: v.string(),
  id: v.string()
});

/**
 * getGenericObservation 200 response
 */
export const vGetGenericObservationResponse = vGenericObservation;

/**
 * getOpenApiJson 200 response
 */
export const vGetOpenApiJsonResponse = v.record(v.string(), v.unknown());

/**
 * getOpenApi 200 response
 */
export const vGetOpenApiResponse = v.string();

/**
 * key 200 response
 */
export const vKeyResponse = v.record(v.string(), v.unknown());

export const vSubscribeBody = vPushSubscription;

export const vUnsubscribeBody = vPushSubscription;

/**
 * getRegions 200 response
 */
export const vGetRegionsResponse = v.array(vRegion);

export const vSaveRegionBody = v.string();

/**
 * saveRegion 200 response
 */
export const vSaveRegionResponse = vRegion;

export const vGetRegionQuery = v.object({
  region: v.string()
});

/**
 * getRegion 200 response
 */
export const vGetRegionResponse = vRegion;

/**
 * configuration
 */
export const vGetLocalServerConfigurationResponse = vLocalServerInstance;

export const vSaveServerConfigurationBody = vServerInstance;

/**
 * saveServerConfiguration 200 response
 */
export const vSaveServerConfigurationResponse = vServerInstance;

/**
 * configuration
 */
export const vGetExternalServerConfigurationsResponse =
  v.array(vServerInstance);

/**
 * server version info
 */
export const vGetServerVersionInfoResponse =
  vServerInstanceServiceServerVersionInfo;

export const vGetBulletinCsvQuery = v.object({
  startDate: v.string(),
  endDate: v.string(),
  lang: vLanguageCode,
  extended: v.optional(v.boolean(), false),
  duplicate: v.optional(v.boolean(), false),
  regions: v.array(v.string()),
  obsoleteMatrix: v.optional(v.boolean(), false)
});

/**
 * getBulletinCsv 200 response
 */
export const vGetBulletinCsvResponse = v.string();

export const vGetDangerSourceCsvQuery = v.object({
  startDate: v.string(),
  endDate: v.string()
});

/**
 * getDangerSourceCsv 200 response
 */
export const vGetDangerSourceCsvResponse = v.string();

export const vSaveVirtualRealityStatisticsBody = v.string();

/**
 * getStatus_1 200 response
 */
export const vGetStatus1Response = v.array(vStatusInformation);

/**
 * triggerStatusChecks 200 response
 */
export const vTriggerStatusChecksResponse = v.array(vStatusInformation);

/**
 * getUsers 200 response
 */
export const vGetUsersResponse = v.array(vUser);

export const vSaveUserBody = vUser;

/**
 * saveUser 200 response
 */
export const vSaveUserResponse = vUser;

export const vChangePasswordBody = vUserServiceChangePassword;

export const vCheckPasswordBody = vUserServiceCheckPassword;

/**
 * getRegions_1 200 response
 */
export const vGetRegions1Response = v.array(v.string());

/**
 * getRoles 200 response
 */
export const vGetRolesResponse = vRole;

export const vGetStressLevelsQuery = v.object({
  startDate: v.string(),
  endDate: v.string()
});

/**
 * getStressLevels 200 response
 */
export const vGetStressLevelsResponse = v.array(vStressLevel);

export const vPostStressLevelBody = vStressLevel;

/**
 * postStressLevel 200 response
 */
export const vPostStressLevelResponse = vStressLevel;

export const vGetTeamStressLevelsQuery = v.object({
  region: v.string(),
  startDate: v.string(),
  endDate: v.string()
});

/**
 * getTeamStressLevels 200 response
 */
export const vGetTeamStressLevelsResponse = v.record(
  v.string(),
  v.array(vStressLevel)
);

export const vDeleteUserPath = v.object({
  id: v.string()
});

export const vResetPasswordBody = vUserServiceResetPassword;

export const vResetPasswordPath = v.object({
  id: v.string()
});

/**
 * Directory listing of the bulletin archive
 */
export const vGetStaticArchiveResponse = v.string();

export const vGetStaticCaamlJsonPath = v.object({
  date: v.pipe(v.string(), v.isoDate()),
  region: v.string(),
  lang: vLanguageCode
});

/**
 * CAAML v6 JSON bulletins
 */
export const vGetStaticCaamlJsonResponse = vCaamlAvalancheBulletins;

export const vGetStaticCaamlXmlPath = v.object({
  date: v.pipe(v.string(), v.isoDate()),
  region: v.string(),
  lang: vLanguageCode
});

/**
 * CAAML v6 XML bulletins
 */
export const vGetStaticCaamlXmlResponse = v.string();

export const vGetStaticCaamlJsonForPublicationPath = v.object({
  date: v.pipe(v.string(), v.isoDate()),
  publication: v.string(),
  region: v.string(),
  lang: vLanguageCode
});

/**
 * CAAML v6 JSON bulletins
 */
export const vGetStaticCaamlJsonForPublicationResponse =
  vCaamlAvalancheBulletins;

export const vGetStaticMapPath = v.object({
  date: v.pipe(v.string(), v.isoDate()),
  publication: v.string(),
  file: v.string()
});

/**
 * Danger map
 */
export const vGetStaticMapResponse = v.string();

export const vGetStaticMp3Path = v.object({
  date: v.pipe(v.string(), v.isoDate()),
  region: v.string(),
  lang: vLanguageCode
});

/**
 * Audio bulletin
 */
export const vGetStaticMp3Response = v.string();

export const vGetStaticEawsProblemsPath = v.object({
  date: v.pipe(v.string(), v.isoDate())
});

/**
 * Avalanche problems keyed by micro-region ID
 */
export const vGetStaticEawsProblemsResponse = v.record(v.string(), v.unknown());

export const vGetStaticEawsRatingsPath = v.object({
  date: v.pipe(v.string(), v.isoDate()),
  region: v.string()
});

/**
 * Danger ratings keyed by micro-region ID
 */
export const vGetStaticEawsRatingsResponse = v.record(v.string(), v.unknown());

/**
 * Weather stations as GeoJSON
 */
export const vGetStaticWeatherStationsResponse =
  vWeatherStationsFeatureCollection;

export const vGetStaticWeatherStationsForDateTimePath = v.object({
  date: v.pipe(v.string(), v.isoDate()),
  dateTime: v.string()
});

/**
 * Weather stations as GeoJSON
 */
export const vGetStaticWeatherStationsForDateTimeResponse =
  vWeatherStationsFeatureCollection;

export const vGetStaticSimpleHtmlPath = v.object({
  date: v.pipe(v.string(), v.isoDate()),
  region: v.string(),
  lang: vLanguageCode
});

/**
 * Simple HTML rendering of the bulletins
 */
export const vGetStaticSimpleHtmlResponse = v.string();
